import { request } from '@blade/common';
/**
 *@Description: 任务列表
 */
export const getTaskList = (data) => request({
    url: '/api/task-management/api/v1/task/bigData/or/cluster/list',
    method: 'POST',
    data,
});
// export const getTaskList = (data: Iconfig) =>
//   request({
//     url: '/api/task-management/api/v1/task/list',
//     method: 'POST',
//     data
//   });
/**
 *@Description: 删除任务
 */
export const deleteTask = (taskId) => request.delete(`/api/task-management/api/v1/task/${taskId}`);
/**
 *@Description: 添加任务
 */
export const postTask = (data) => request.post('/api/task-management/api/v1/createTask', data);
/**
 *@Description: 任务详情
 */
export const getTaskDetail = (id) => request.get(`/api/task-management/api/v1/task/${id}`);
/**
 *@Description: 查询设备
 */
export const deviceList = () => request.get(`/api/map-management//api/v1/map/device/tree`);
/**
 *@Description: 查询区域
 */
export const zoneList = (data) => request.post(`/api/map-management/api/v1/map/zone/tree`, data);
